// @ts-nocheck
export default defineNuxtRouteMiddleware(() => {
  const { closeDrawer } = useDrawer()
  closeDrawer()
})
